import React from "react";
import { useLocation } from "react-router-dom";
import { NotificationButton } from "./NotificationCenter";
import { useAuth } from "../../data/authStore";

// Floating, fixed top-right action bar for global app actions.
// iter-182 — the legacy SearchButton is now replaced by the new
// GlobalCommandBar (top-left of content area). FloatingTopBar
// retains the notification bell only.
// Only renders for authenticated users on app routes (not /login,
// /signup, /forgot-password, /reset-password, /, /pricing).
const PUBLIC_PATHS = new Set(["/", "/pricing", "/login", "/signup", "/forgot-password", "/reset-password"]);
// Pages with their own integrated topbar / dark theme — global floating bar would clash visually.
const SUPPRESSED_PREFIXES = ["/dashboard", "/deal-rooms"];

export const FloatingTopBar = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (!user || PUBLIC_PATHS.has(pathname)) return null;
  if (SUPPRESSED_PREFIXES.some((p) => pathname.startsWith(p))) return null;
  return (
    <div
      className="fixed top-4 right-6 z-30 hidden md:flex items-center gap-2"
      data-testid="floating-topbar"
    >
      <NotificationButton />
    </div>
  );
};
